const { API_ENV } = process.env

const checkLocalVersion = () => {
  fetch('./meta.json')
    .then((resp) => resp.json())
    .then(async (meta) => {
      const ref = `leroy-meta-version-${API_ENV}`
      const { version } = meta
      const oldVersion = localStorage.getItem(ref)

      if (version) {
        if (version !== oldVersion) {
          localStorage.clear()

          if (caches) {
            await caches.keys().then((names) => {
              for (const name of names) caches.delete(name)
            })
          }

          localStorage.setItem(ref, version)

          window.location.reload(true)
        }
      }
    })
}

export default checkLocalVersion
